import type { FaireProductEntity } from "../../entity_types/product";

export const p_5jt2wmsc27: FaireProductEntity = {
  token: "p_5jt2wmsc27",
  type: "product",
  name: "Peace To My Soul - Customizable - 1/2 Zip Pullover",
  brandToken: "b_1bd10jxt4j",
  brandName: "MT Brand Apparel",
  imageUrl: "https://cdn.faire.com/fastly/885f68ba5ef4617acc3d558aba2b79102ab3695bc14e081f5d225166a107900e.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/72aaf7fe1b2dcc8f3eb27826d5efc412db794d1125b92318230fb3dfe366ee8f.png",
    "https://cdn.faire.com/fastly/97606519077c6b051f285e7ecbfce82412893b000dafa8030bad3037d73e1aba.png",
    "https://cdn.faire.com/fastly/da96ae9f0233dbee8d5d0ae162a63455752ad5a7a837c6e9b72f8ca51f578694.png",
    "https://cdn.faire.com/fastly/3ff1f23ffa2341b1f0928c44efe99637c0d90f5fb0f340f31ccd35ee5a53ab0e.png"
  ],
  priceDollars: 34,
  description: "We LOOOOOVE this new pullover. It has everything we love. 1/2 zip extended neck collar, all metal zipper, nicely finished zipper pull, raglan sleeves and a front pocket. The fit is true to size. Relaxed yet boxy.\nFour fun colors available in sizes X-Small through 3X-Large. The garment is made of 68% Cotton and 32% Polyester and manufactured for One Stop LLC.\n\nWe will add your custom location underneath the Peace To My Soul graphic on the left chest of the garment. We will replace Sunapee, Glacier, Twain Harte and Stowe. Please add your custom location in the space provided.",
  tags: [],
  msrpDollars: 68,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:03:47.898Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
